
import { Container, Grid, Paper, Typography } from "@mui/material";

import Messages from "../messages";
import Chart from "./widgets/Chart";
import Summary from "./widgets/Summary";

function Dashboard() {
    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper
                        sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            height: 300,
                        }}
                    >
                        <Chart />
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper
                        sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            height: 300,
                        }}
                    >
                        <Summary />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                        <Typography component="h2" variant="h6" color="heading" gutterBottom>System Messages</Typography>
                        <Messages records={5} />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Dashboard;